// === INPACT:SLUITSTRAAT:FRISIA:MAIN:v2 ===

import React from 'react';
import ReactDOM from 'react-dom/client';
// Import defaultLanguage and i18n instance to apply Frisia-specific translation overrides
import { defaultLanguage, bffClient } from '@sluitstraat/core';
import i18n from 'i18next';
import App from './App';
import './index.css';
import 'flag-icons/css/flag-icons.min.css';

// Frisia-specific translation overrides (loaded from local files)
import frisiaOverridesNl from './i18n/nl.json';
import frisiaOverridesEn from './i18n/en.json';

// Log to verify i18n initialization (development only)
if (import.meta.env.DEV) {
  console.log('i18n default language:', defaultLanguage);
}

// Deep merge Frisia-specific translations into the existing i18n resources
// This overrides shared core translations with Frisia-local values
i18n.addResourceBundle('nl', 'translation', frisiaOverridesNl, true, true);
i18n.addResourceBundle('en', 'translation', frisiaOverridesEn, true, true);

// Clear monument property flags on app initialization (fresh page load)
// These will be re-determined by address lookup during the session
try {
  sessionStorage.removeItem('woonhuis_monument_property');
  sessionStorage.removeItem('inboedel_monument_property');
} catch (e) {
  // Ignore sessionStorage errors
}

// Configure BFF client with environment variables
// Direct access to import.meta.env ensures Vite includes these vars in production builds
bffClient.setTenantId(import.meta.env.VITE_TENANT_ID || 'glider');
if (import.meta.env.VITE_BFF_BASE_URL) {
  bffClient.configure(import.meta.env.VITE_BFF_BASE_URL);
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
